module.exports = __webpack_public_path__ + "static/img/testimony3.7cb889e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/testimony3.png
// module id = DCo0
// module chunks = 1 3